import { Dispatch, SetStateAction } from 'react'
import { DefaultErrorState, QuantityDiscountorBlockConfigType } from 'src/lib/types/discounts'
import {
  DiscountFormStateType,
  DiscountFormErrorState,
  GenerationType,
  ApplicationStageType,
  JourneyStepType,
  PaymentModeConcessionConfigType
} from 'src/lib/types/discounts'
import { alertSeverites } from '../constants'
import { isUndefinedOrNull, isUndefinedOrNullOrNaNOrEmpty, isValidDate, isValidEndDate } from '../helpers'
import { initialFormErrorState } from 'src/assets/DiscountsConfig'
import { CogSyncOutline } from 'mdi-material-ui'

export const errorMappings = {
  DC_FORM_001: 'Please enter a title',
  DC_FORM_002: 'Please enter the code',
  // "DC_FORM_003": "Please remove spaces in the code",
  DC_FORM_004: 'Please enter the number of codes to generate',
  DC_FORM_005: 'Please enter the code length',
  DC_FORM_006: 'Please enter the offer value',
  DC_FORM_007: 'Please enter the offer limit',
  DC_FORM_008: 'Please enter the quantity',
  DC_FORM_009: 'Please select at least 1 item',
  DC_FORM_012: 'Please enter the minimum value',
  // "DC_FORM_013": "Minimum required quantity should greater than bundle size",
  // "DC_FORM_014": "Please enter the maximum value",
  DC_FORM_015: 'Maximum value should be greater than minimum value',
  // "DC_FORM_016": "Please select atleast 1 item",
  DC_FORM_017: 'Please enter a valid date and time',
  DC_FORM_018: 'Please enter a valid date and time',
  DC_FORM_019: 'Discounts cannot time travel',
  DC_FORM_020: 'Please set the offer timeout',
  DC_FORM_021: 'Please set maximum discount uses',
  DC_FORM_022: 'Pleae enter minimum order count',
  DC_FORM_023: 'Please enter maximum order count',
  DC_FORM_024: 'Please enter a valid email',
  DC_FORM_025: 'Percentage cannot be more than 100',
  DC_FORM_026: 'Please select at least 1 payment method.',
  DC_FORM_027: 'Please upload a csv file with the correct format.',
  DC_FORM_028: "You can't select same Item in different groups",
  DC_FORM_029: 'Please enter a callout title',
  DC_FORM_030: 'Please enter subheading',
  DC_FORM_031: 'Please enter body text',
  DC_FORM_032: 'Please select at least one freebie item',
  DC_FORM_033: 'Please enter a title',
  DC_FORM_034: "Max users can't be empty",
  DC_FORM_035: 'Please set maximum discount uses per customer',
  DC_FORM_036: 'Please enter the price',
  DC_FORM_037: 'Maximum value should be greater than or equal to minimum value',
  DC_FORM_038: 'Please select at least 1 segment',
  DC_FORM_039: 'End date cannot be more than 3 months from start date',
  DC_FORM_040: 'End date cannot be in behind of start date',
  DC_FORM_041: 'Please enter value greater than 0',
  DC_FORM_042: 'Bundle size must be at least 1',
  DC_FORM_043: 'Start date must be before end date'
}

const setErrorMessage = (
  errorCodeValue: string,
  errorKey: string,
  errorObject: { status: boolean },
  setFormErrors: Dispatch<SetStateAction<DiscountFormErrorState>>,
  handleAlerts: (severity: string, message?: string) => void,
  indexes?: number[]
) => {
  const errorState = { status: true, errorCode: errorCodeValue }
  const quantityDistributorErrorState = { status: true, errorCode: errorCodeValue, indexes }
  const quantityDistributorProductErrorState = { status: true, errorCode: errorCodeValue, indexes }

  const setFormErrorState = (errorObj: any) => {
    setFormErrors((oldValues: DiscountFormErrorState) => ({ ...oldValues, ...errorObj }))
  }

  switch (errorKey) {
    //identifier
    case 'identifier':
      setFormErrorState({ identifier: errorState })
      break

    case 'discountTitle':
      setFormErrorState({ discountTitle: errorState })
      break

    case 'discountHeader':
      setFormErrorState({ discountHeader: errorState })
      break

    case 'discountDescription':
      setFormErrorState({ discountDescription: errorState })
      break

    //bulk generation inputs
    case 'codeCount':
      setFormErrorState({ codeCount: errorState })
      break
    case 'codeLength':
      setFormErrorState({ codeLength: errorState })
      break
    case 'codeCSV':
      setFormErrorState({ codeCSV: errorState })
      break
    // offer inputs
    case 'offerValue':
      setFormErrorState({ offerValue: errorState })
      break
    case 'offerLimit':
      setFormErrorState({ offerLimit: errorState })
      break
    case 'entitledQuantity':
      setFormErrorState({ entitledQuantity: errorState })
      break

    //threshold inputs
    case 'minRequirement':
      setFormErrorState({ minRequirement: errorState })
      break
    case 'maxRequirement':
      setFormErrorState({ maxRequirement: errorState })
      break

    //customer eligibility inputs
    case 'minOrderCount':
      setFormErrorState({ minOrderCount: errorState })
      break
    case 'maxOrderCount':
      setFormErrorState({ maxOrderCount: errorState })
      break

    //usage limit inputs
    case 'maxUses':
      setFormErrorState({ maxUses: errorState })
      break
    case 'customerCSV':
      setFormErrorState({ customerCSV: errorState })
      break
    case 'customerSegments':
      setFormErrorState({ customerSegments: errorState })
      break

    //Catalogue selections
    case 'prerequisteProducts':
      setFormErrorState({ prerequisteProducts: errorState })
      break
    case 'entitledProducts':
      setFormErrorState({ entitledProducts: errorState })
      break
    case 'coveredProducts':
      setFormErrorState({ coveredProducts: errorState })
      break

    //Active period inputs
    case 'endDate':
      setFormErrorState({ endDate: errorState })
      break
    case 'startDate':
      setFormErrorState({ startDate: errorState })
      break
    case 'activePeriod':
      setFormErrorState({ activePeriod: errorState })
      break
    case 'paymentModeChecklist':
      setFormErrorState({ paymentModeChecklist: errorState })
      break
    case 'maxUsesPerOrder':
      setFormErrorState({ maxUsesPerOrder: errorState })
    case 'maxUsesPerCustomer':
      setFormErrorState({ maxUsesPerCustomer: errorState })
      break
    case 'quantityDistributor':
      setFormErrorState({ quantityDistributor: quantityDistributorErrorState })
      break
    case 'quantityDistributorProduct':
      setFormErrorState({ quantityDistributorProduct: quantityDistributorProductErrorState })
      break
    case 'paymentModeValue':
      setFormErrorState({ individidualPaymentModeVal: errorState })
      break
    case 'paymentModeValueUpto':
      setFormErrorState({ individidualPaymentModeValUpto: errorState })
      break
  }

  // handleAlerts(
  //     alertSeverites.SEVERITY_ERROR,
  //     "Some inputs might be filled incorrect!"
  // );
  errorObject.status = true
}

export const isInvalidForm = (
  discountFormState: DiscountFormStateType | undefined,
  setFormErrors: Dispatch<SetStateAction<DiscountFormErrorState>>,
  handleAlerts: (severity: string, message?: string) => void,
  isEditMode: boolean,
  generationType: GenerationType | undefined,
  applicationStage: ApplicationStageType | undefined
  //   currentStep: JourneyStepType
) => {
  const { setup, conditions, customerEligibility, usageLimits } = discountFormState || {}

  const { applicationMethodConfig, applicationConfig } = setup || {}

  const { offerValueConfig, entitlementsConfig, discountGenerationConfig } = applicationConfig || {}

  const { thresholdConfig, prerequisitesConfig } = conditions || {}

  const { discountUsesConfig, activePeriodConfig } = usageLimits || {}

  const errorFound = { status: false }

  setFormErrors(initialFormErrorState)

  if (applicationConfig?.valueType === 'CALLOUT_CARD') {
    !Boolean(applicationConfig?.discountDescription?.discountTitle?.trim()?.length) &&
      setErrorMessage('DC_FORM_029', 'discountTitle', errorFound, setFormErrors, handleAlerts)

    !Boolean(applicationConfig?.discountDescription?.discountHeader?.trim()?.length) &&
      setErrorMessage('DC_FORM_030', 'discountHeader', errorFound, setFormErrors, handleAlerts)

    !Boolean(applicationConfig?.discountDescription?.discountDescription?.trim()?.length) &&
      setErrorMessage('DC_FORM_031', 'discountDescription', errorFound, setFormErrors, handleAlerts)
  }

  //Input Field: Indentifier
  if (applicationStage === 'CART_DISCOVERY' || applicationStage === 'PRE_PAYMENT_VALIDATION') {
    if (generationType === 'SINGLE') {
      if (applicationMethodConfig?.valueType === 'AUTOMATIC') {
        !Boolean(applicationMethodConfig?.value?.trim()?.length) &&
          setErrorMessage('DC_FORM_001', 'identifier', errorFound, setFormErrors, handleAlerts)
      } else {
        if (!Boolean(applicationMethodConfig?.value?.trim()?.length)) {
          setErrorMessage('DC_FORM_002', 'identifier', errorFound, setFormErrors, handleAlerts)
        }
        // else {
        //     !Boolean(applicationMethodConfig?.value?.match(/\s/)) &&
        //     setErrorMessage("DC_FORM_003", "identifier", errorFound, setFormErrors, handleAlerts);
        // }
      }
    } else {
      !Boolean(applicationMethodConfig?.value?.trim()?.length) &&
        setErrorMessage('DC_FORM_001', 'identifier', errorFound, setFormErrors, handleAlerts)
    }
  }

  //Input Field: Code count
  if (
    applicationStage === 'CART_DISCOVERY' &&
    generationType === 'BULK' &&
    discountGenerationConfig?.bulkGenerationConfig?.valueType === 'RANDOM_CODES' &&
    isUndefinedOrNullOrNaNOrEmpty(discountGenerationConfig?.bulkGenerationConfig?.codeCount)
  ) {
    setErrorMessage('DC_FORM_004', 'codeCount', errorFound, setFormErrors, handleAlerts)
  }

  //Input Field: Code length
  if (
    applicationStage === 'CART_DISCOVERY' &&
    generationType === 'BULK' &&
    discountGenerationConfig?.bulkGenerationConfig?.valueType === 'RANDOM_CODES' &&
    isUndefinedOrNullOrNaNOrEmpty(discountGenerationConfig?.bulkGenerationConfig?.codeLength)
  ) {
    setErrorMessage('DC_FORM_005', 'codeLength', errorFound, setFormErrors, handleAlerts)
  }

  //File upload: Bulk discount
  if (
    applicationStage === 'CART_DISCOVERY' &&
    generationType === 'BULK' &&
    discountGenerationConfig?.bulkGenerationConfig?.valueType === 'CSV_UPLOAD' &&
    !isEditMode &&
    isUndefinedOrNull(discountGenerationConfig?.bulkGenerationConfig?.uploadedFilePath)
  ) {
    setErrorMessage('DC_FORM_027', 'codeCSV', errorFound, setFormErrors, handleAlerts)
  }

  //File upload: Customer context
  if (
    (applicationStage === 'CART_DISCOVERY' || applicationStage === 'PRE_PAYMENT_VALIDATION') &&
    !isEditMode &&
    customerEligibility?.valueType === 'SPECIFIC' &&
    isUndefinedOrNull(customerEligibility?.uploadedFilePath)
  ) {
    setErrorMessage('DC_FORM_027', 'customerCSV', errorFound, setFormErrors, handleAlerts)
  }

  //Input Field: Offer value
  if (applicationConfig?.valueType !== 'CALLOUT_CARD') {
    if (
      !Boolean(
        applicationStage === 'PRE_PAYMENT_VALIDATION' && offerValueConfig?.paymentModeCoverageType === 'SPECIFIC'
      ) &&
      offerValueConfig?.valueType !== 'FREEBIE' &&
      isUndefinedOrNullOrNaNOrEmpty(offerValueConfig?.value)
    ) {
      setErrorMessage('DC_FORM_006', 'offerValue', errorFound, setFormErrors, handleAlerts)
    } else if (offerValueConfig?.valueType === 'FLAT' && offerValueConfig?.paymentModeCoverageType === 'ALL') {
      parseFloat(offerValueConfig.value.toString()) < 1 &&
        setErrorMessage('DC_FORM_006', 'offerValue', errorFound, setFormErrors, handleAlerts)
    } else if (offerValueConfig?.valueType === 'PERCENTAGE' && offerValueConfig?.paymentModeCoverageType === 'ALL') {
      parseFloat(offerValueConfig.value.toString()) < 1 &&
        setErrorMessage('DC_FORM_006', 'offerValue', errorFound, setFormErrors, handleAlerts)
      parseFloat(offerValueConfig.value.toString()) > 100 &&
        setErrorMessage('DC_FORM_025', 'offerValue', errorFound, setFormErrors, handleAlerts)
    } else if (
      offerValueConfig?.valueType === 'PERCENTAGE_CAPPED' &&
      offerValueConfig?.paymentModeCoverageType === 'ALL'
    ) {
      parseFloat(offerValueConfig.value.toString()) < 1 &&
        setErrorMessage('DC_FORM_006', 'offerValue', errorFound, setFormErrors, handleAlerts)
      parseFloat(offerValueConfig.value.toString()) > 100 &&
        setErrorMessage('DC_FORM_025', 'offerValue', errorFound, setFormErrors, handleAlerts)
        ; (isUndefinedOrNullOrNaNOrEmpty(offerValueConfig?.cappedValue) || Number(offerValueConfig?.cappedValue) === 0) &&
          setErrorMessage('DC_FORM_007', 'offerLimit', errorFound, setFormErrors, handleAlerts)
    }
  }
  // Input Field: Offer value - Payment Mode
  if (
    offerValueConfig?.paymentModeConcessions?.length &&
    offerValueConfig?.valueType !== 'FREEBIE' &&
    offerValueConfig.paymentModeCoverageType === 'SPECIFIC'
  ) {
    const { paymentModeConcessions } = offerValueConfig
    const checkedModes = paymentModeConcessions.filter(
      mode => mode.paymentModeCheckboxConfig?.valueType && mode.valueType !== 'COD'
    )

    checkedModes.forEach(mode => {
      if (!mode.concessionAmount) {
        setErrorMessage('DC_FORM_041', 'paymentModeValue', errorFound, setFormErrors, handleAlerts)
      }
      if (offerValueConfig?.valueType === 'PERCENTAGE_CAPPED' && !mode?.maxConcessionAmount) {
        setErrorMessage('DC_FORM_041', 'paymentModeValueUpto', errorFound, setFormErrors, handleAlerts)
      }
    })
  }

  //Input Field: Offer limit
  // if (Boolean(offerValueConfig?.capCheckboxConfig?.valueType) &&
  //     (isUndefinedOrNullOrNaNOrEmpty(offerValueConfig?.cappedValue) && Number(offerValueConfig?.cappedValue) === 0)) {
  //     setErrorMessage("DC_FORM_007", "offerLimit", errorFound, setFormErrors, handleAlerts);
  // }

  //Input Field: Entitled quantity / Bundle size
  if (applicationStage === 'CART_DISCOVERY' && applicationConfig?.valueType === 'BUNDLE') {
    if (
      isUndefinedOrNullOrNaNOrEmpty(offerValueConfig?.quantity) ||
      Number(offerValueConfig?.quantity) < 1
    ) {
      setErrorMessage('DC_FORM_042', 'entitledQuantity', errorFound, setFormErrors, handleAlerts)
    }
  }

  //Catalogue Search: Entitled/Covered products
  // if (applicationStage === "CART_DISCOVERY") {
  //     switch (applicationConfig?.valueType) {
  //         case "AMOUNT":
  //             (Boolean(entitlementsConfig?.valueType !== "ALL") &&
  //                 !Boolean(entitlementsConfig?.entitledItemsConfig?.items?.length ||
  //                 entitlementsConfig?.entitledItemsConfig?.variants?.length)) &&
  //                 setErrorMessage("DC_FORM_009", "coveredProducts", errorFound, setFormErrors, handleAlerts);
  //             break;
  //         case "BXGY":
  //             (!Boolean(entitlementsConfig?.entitledItemsConfig?.variants?.length) && !Boolean(entitlementsConfig?.entitledItemsConfig?.items?.length)) &&
  //                 setErrorMessage("DC_FORM_009", "entitledProducts", errorFound, setFormErrors, handleAlerts);
  //             break;
  //         case "BUNDLE":
  //             (Boolean(entitlementsConfig?.valueType !== "ALL") &&
  //                 !Boolean(entitlementsConfig?.entitledItemsConfig?.variants?.length ||
  //                 entitlementsConfig?.entitledItemsConfig?.items?.length)) &&
  //                 setErrorMessage("DC_FORM_009", "entitledProducts", errorFound, setFormErrors, handleAlerts);
  //             break;
  //     }
  // }

  //Input Field: Minimum threshold
  if (
    (applicationStage === 'CART_DISCOVERY' || applicationStage === 'PRE_PAYMENT_VALIDATION') &&
    thresholdConfig?.valueType !== 'NONE'
  ) {
    if (applicationConfig?.valueType !== 'BUNDLE') {
      Boolean(
        prerequisitesConfig?.valueType === 'ALL' &&
        Boolean(isUndefinedOrNullOrNaNOrEmpty(thresholdConfig?.minValue) || Number(thresholdConfig?.minValue) < 1)
      ) && setErrorMessage('DC_FORM_012', 'minRequirement', errorFound, setFormErrors, handleAlerts)
    }
    // else {
    //     (applicationConfig?.valueType === "BUNDLE") &&
    //     thresholdConfig?.minValue && offerValueConfig?.quantity &&
    //     Boolean(thresholdConfig?.minValue < offerValueConfig?.quantity) &&
    //     setErrorMessage("DC_FORM_013", "minRequirement", errorFound, setFormErrors, handleAlerts);
    // }
  }

  //Input Field: Maximum threshold
  if (
    (applicationStage === 'CART_DISCOVERY' || applicationStage === 'PRE_PAYMENT_VALIDATION') &&
    thresholdConfig?.valueType !== 'NONE' &&
    Boolean(thresholdConfig?.maxCheckboxConfig?.valueType) &&
    prerequisitesConfig?.valueType === 'ALL'
  ) {
    // if (isUndefinedOrNullOrNaNOrEmpty(thresholdConfig?.maxValue)) {
    //     setErrorMessage("DC_FORM_014", "maxRequirement", errorFound, setFormErrors, handleAlerts);
    // }
    if (!thresholdConfig?.maxValue)
      setErrorMessage('DC_FORM_015', 'maxRequirement', errorFound, setFormErrors, handleAlerts)
    if (
      thresholdConfig?.maxValue &&
      thresholdConfig?.minValue &&
      Boolean(
        parseFloat(thresholdConfig.maxValue.toString()) < parseFloat(thresholdConfig.minValue.toString()) ||
        Boolean(Number(thresholdConfig?.maxValue) < 1)
      )
    ) {
      setErrorMessage('DC_FORM_015', 'maxRequirement', errorFound, setFormErrors, handleAlerts)
    }
  }

  //Catalogue Search: Prerequisite products
  if (
    (applicationStage === 'CART_DISCOVERY' || applicationStage === 'PRE_PAYMENT_VALIDATION') &&
    applicationConfig?.valueType !== 'BUNDLE' &&
    prerequisitesConfig?.valueType !== 'ALL'
  ) {
    let itemCount = 0
    prerequisitesConfig?.quantityDistributorConfig?.forEach(
      (item: QuantityDiscountorBlockConfigType, index: number) => {
        itemCount += Boolean(item?.itemsConfig?.catalogueMetadata?.length) ? 1 : 0
        prerequisitesConfig?.quantityDistributorConfig?.forEach(
          (lineItem: QuantityDiscountorBlockConfigType, i: number) => {
            if (index === i) return
            if (
              lineItem?.itemsConfig?.items?.some(p => item?.itemsConfig?.items?.includes(p)) ||
              lineItem?.itemsConfig?.variants?.some(p => item?.itemsConfig?.variants?.includes(p))
            ) {
              setErrorMessage('DC_FORM_028', 'prerequisteProducts', errorFound, setFormErrors, handleAlerts)
            }
          }
        )
      }
    )

    const quantityDistributorErrors: number[] = []
    const quantityDistributorProductErrors: number[] = []
    let quantityDistributorErrorType: string = ''

    prerequisitesConfig?.quantityDistributorConfig?.forEach(
      (item: QuantityDiscountorBlockConfigType, index: number) => {
        if (thresholdConfig?.valueType === 'AMOUNT' && !Boolean(item?.price) && item?.price !== null) {
          quantityDistributorErrors.push(index)
          quantityDistributorErrorType = 'DC_FORM_036'
        }
        if (thresholdConfig?.valueType === 'QUANTITY' && !Boolean(item?.quantity) && item?.quantity !== null) {
          quantityDistributorErrors.push(index)
          quantityDistributorErrorType = 'DC_FORM_008'
        }
        if (Boolean(item?.maxEnabled)) {
          if (
            Boolean(
              (thresholdConfig?.valueType === 'AMOUNT' && Boolean(!item?.maxPrice)) ||
              Number(item.maxPrice) < Number(item.price)
            ) ||
            Boolean(
              (thresholdConfig?.valueType === 'QUANTITY' && Boolean(!item?.maxQuantity)) ||
              Number(item.maxQuantity) < Number(item.quantity)
            )
          ) {
            quantityDistributorErrors.push(index)
            quantityDistributorErrorType = 'DC_FORM_037'
          }
        }
        if (
          item?.itemsConfig?.catalogueMetadata?.length === 0 ||
          !Boolean(item?.itemsConfig?.catalogueMetadata?.length)
        ) {
          quantityDistributorProductErrors.push(index)
        }
      }
    )
    if (quantityDistributorErrors.length > 0) {
      setErrorMessage(
        quantityDistributorErrorType,
        'quantityDistributor',
        errorFound,
        setFormErrors,
        handleAlerts,
        quantityDistributorErrors
      )
    }
    if (quantityDistributorProductErrors.length > 0) {
      setErrorMessage(
        'DC_FORM_009',
        'quantityDistributorProduct',
        errorFound,
        setFormErrors,
        handleAlerts,
        quantityDistributorProductErrors
      )
    }
  }

  if (entitlementsConfig?.valueType !== 'ALL') {
    let itemCount = 0
    entitlementsConfig?.quantityDistributorConfig?.forEach((item: QuantityDiscountorBlockConfigType, index: number) => {
      itemCount += Boolean(item?.itemsConfig?.catalogueMetadata?.length) ? 1 : 0
      entitlementsConfig?.quantityDistributorConfig?.forEach(
        (lineItem: QuantityDiscountorBlockConfigType, i: number) => {
          if (index === i) return
          if (
            lineItem?.itemsConfig?.items?.some(p => item?.itemsConfig?.items?.includes(p)) ||
            lineItem?.itemsConfig?.variants?.some(p => item?.itemsConfig?.variants?.includes(p))
          ) {
            setErrorMessage('DC_FORM_028', 'entitledQuantity', errorFound, setFormErrors, handleAlerts)
          }
        }
      )
    })

    const quantityDistributorErrors: number[] = []
    const quantityDistributorProductErrors: number[] = []
    entitlementsConfig?.quantityDistributorConfig?.forEach((item: QuantityDiscountorBlockConfigType, index: number) => {
      if (!Boolean(item?.quantity) && item?.quantity !== null) {
        quantityDistributorErrors.push(index)
      } else if (
        item?.itemsConfig?.catalogueMetadata?.length === 0 ||
        !Boolean(item?.itemsConfig?.catalogueMetadata?.length)
      ) {
        quantityDistributorProductErrors.push(index)
      }
    })
    if (quantityDistributorErrors.length > 0) {
      setErrorMessage(
        'DC_FORM_008',
        'quantityDistributor',
        errorFound,
        setFormErrors,
        handleAlerts,
        quantityDistributorErrors
      )
    }
    if (quantityDistributorProductErrors.length > 0) {
      setErrorMessage(
        'DC_FORM_009',
        'quantityDistributorProduct',
        errorFound,
        setFormErrors,
        handleAlerts,
        quantityDistributorProductErrors
      )
    }
  }

  //Input Field: Start date
  if (
    (applicationStage === 'CART_DISCOVERY' || applicationStage === 'PRE_PAYMENT_VALIDATION') &&
    !isValidDate(activePeriodConfig?.startDate)
  ) {
    setErrorMessage('DC_FORM_017', 'startDate', errorFound, setFormErrors, handleAlerts)
  }

  //Input Field: End date
  if (
    (applicationStage === 'CART_DISCOVERY' || applicationStage === 'PRE_PAYMENT_VALIDATION') &&
    Boolean(activePeriodConfig?.endDataCheckboxConfig?.valueType)
  ) {
    if (!isValidDate(activePeriodConfig?.endDate)) {
      setErrorMessage('DC_FORM_018', 'endDate', errorFound, setFormErrors, handleAlerts)
    } else {
      // Validation for end date > start date
      !isValidEndDate(activePeriodConfig?.endDate, activePeriodConfig?.startDate) &&
        setErrorMessage('DC_FORM_019', 'endDate', errorFound, setFormErrors, handleAlerts)
    }
  }

  //Input Field: Active period
  if (applicationStage === 'POST_ORDER_PLACEMENT' && isUndefinedOrNullOrNaNOrEmpty(activePeriodConfig?.activePeriod)) {
    setErrorMessage('DC_FORM_020', 'activePeriod', errorFound, setFormErrors, handleAlerts)
  }

  //Input Field: Max uses
  if (
    applicationStage === 'CART_DISCOVERY' &&
    generationType !== 'BULK' &&
    Boolean(discountUsesConfig?.maxUsesCheckboxConfig?.valueType) &&
    isUndefinedOrNullOrNaNOrEmpty(discountUsesConfig?.maxUses)
  ) {
    setErrorMessage('DC_FORM_021', 'maxUses', errorFound, setFormErrors, handleAlerts)
  }

  //Input Field: Minimum order count
  if (
    (applicationStage === 'CART_DISCOVERY' || applicationStage === 'PRE_PAYMENT_VALIDATION') &&
    customerEligibility?.valueType === 'CONDITIONAL' &&
    isUndefinedOrNullOrNaNOrEmpty(customerEligibility?.minOrderCount)
  ) {
    setErrorMessage('DC_FORM_022', 'minOrderCount', errorFound, setFormErrors, handleAlerts)
  }

  if (
    (applicationStage === 'CART_DISCOVERY' || applicationStage === 'PRE_PAYMENT_VALIDATION') &&
    customerEligibility?.valueType === 'CONDITIONAL' &&
    customerEligibility?.maxOrderCountCheckboxConfig?.valueType &&
    isUndefinedOrNullOrNaNOrEmpty(customerEligibility?.maxOrderCount)
  ) {
    setErrorMessage('DC_FORM_023', 'maxOrderCount', errorFound, setFormErrors, handleAlerts)
  }

  // Input Field: Maximum order count
  // if ((applicationStage === "CART_DISCOVERY" || applicationStage === "PRE_PAYMENT_VALIDATION") && customerEligibility?.valueType === "CONDITIONAL" &&
  //     Boolean(customerEligibility?.maxOrderCountCheckboxConfig?.valueType) &&
  //     isUndefinedOrNullOrNaNOrEmpty(customerEligibility?.maxOrderCount)) {
  //     setErrorMessage("DC_FORM_023", "maxOrderCount", errorFound, setFormErrors, handleAlerts);
  // }

  if (
    (applicationStage === 'CART_DISCOVERY' || applicationStage === 'PRE_PAYMENT_VALIDATION') &&
    customerEligibility?.valueType === 'CONDITIONAL' &&
    Boolean(customerEligibility?.maxOrderCountCheckboxConfig?.valueType) &&
    customerEligibility?.maxOrderCount &&
    customerEligibility.minOrderCount &&
    parseFloat(customerEligibility.maxOrderCount.toString()) < parseFloat(customerEligibility?.minOrderCount.toString())
  ) {
    setErrorMessage('DC_FORM_015', 'maxOrderCount', errorFound, setFormErrors, handleAlerts)
  }

  //User Segment: Customer context
  if (
    (applicationStage === 'CART_DISCOVERY' || applicationStage === 'PRE_PAYMENT_VALIDATION') &&
    customerEligibility?.valueType === 'SEGMENTS' &&
    !Boolean(customerEligibility?.segmentIds?.length)
  ) {
    setErrorMessage('DC_FORM_038', 'customerSegments', errorFound, setFormErrors, handleAlerts)
  }

  if (applicationStage === 'PRE_PAYMENT_VALIDATION' && offerValueConfig?.paymentModeCoverageType === 'SPECIFIC') {
    let methodCount = 0
    offerValueConfig?.paymentModeConcessions?.forEach(
      (mode: PaymentModeConcessionConfigType) =>
        (methodCount += Boolean(mode?.paymentModeCheckboxConfig?.valueType) ? 1 : 0)
    )
    if (!Boolean(methodCount))
      setErrorMessage('DC_FORM_026', 'paymentModeChecklist', errorFound, setFormErrors, handleAlerts)
  }

  if (applicationStage === 'PRE_PAYMENT_VALIDATION' && offerValueConfig?.isCustomHeader === 'CUSTOM') {
    if (!Boolean(setup?.applicationConfig?.discountDescription?.discountHeader?.length)) {
      setErrorMessage('DC_FORM_033', 'discountHeader', errorFound, setFormErrors, handleAlerts)
    }
  }

  if (
    applicationStage === 'CART_DISCOVERY' &&
    generationType !== 'BULK' &&
    Boolean(discountUsesConfig?.maxUsesPerCustomerCheckboxConfig?.valueType) &&
    isUndefinedOrNullOrNaNOrEmpty(discountUsesConfig?.maxUsesPerCustomer)
  ) {
    setErrorMessage('DC_FORM_035', 'maxUsesPerCustomer', errorFound, setFormErrors, handleAlerts)
  }

  if (
    Boolean(applicationConfig?.maxUsesPerOrderCheckboxConfig?.valueType) &&
    isUndefinedOrNullOrNaNOrEmpty(applicationConfig?.maxUsesPerOrder)
  ) {
    setErrorMessage('DC_FORM_034', 'maxUsesPerOrder', errorFound, setFormErrors, handleAlerts)
  }

  return errorFound.status
}
